import React from "react";
import AceBackground from "../shared/AceBackground";
import appLogo from "../../assets/logo/applogo.png";

export default function AuthLayout({
  children,
  title = "AceTime Admin-Panel",
}) {
  return (
    <div className="ac-authpage">
      <div className="ac-authbg" aria-hidden="true">
        <AceBackground />
      </div>

      <div className="ac-authshell">
        <div className="ac-authbrand">
          <div className="ac-authbrand-logoWrap">
            <img
              src={appLogo}
              alt="AceTime Logo"
              className="ac-authbrand-logo"
            />
          </div>

          <div className="ac-authbrand-copy">
            <div className="ac-authbrand-title">{title}</div>
            <div className="ac-authbrand-subtitle">
              Deine Zeit. Deine Balance. Dein Erfolg.
            </div>
          </div>
        </div>

        <div className="ac-authcard">
          <div className="ac-authcard-glow" aria-hidden="true" />
          <div className="ac-auth-card">{children}</div>
        </div>

        <div className="ac-authfooter">© AceTime · Admin-Panel</div>
      </div>
    </div>
  );
}
